import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';
import { integrationConfigurationsQuery } from '@gonfalon/rest-api/queries/integrationConfigurations';
import { noop } from 'lodash';
import { z } from 'zod';

import type { MetricDataSourceEditorForm } from './useMetricDataSourceForm';

export const warehouseExperimentationConfigValuesSchema = z.object({
  selectedEnv: z.object({
    environmentId: z.string(),
    environmentKey: z.string(),
    projectId: z.string(),
    projectKey: z.string(),
  }),
});

export const warehouseExperimentationConfigValuesMatchingSchema = z.object({
  selectedEnv: z.object({
    environmentKey: z.string(),
    projectKey: z.string(),
  }),
});

export const getIntegrationFieldDefaultValue = async ({ searchParams }: { searchParams: URLSearchParams }) => {
  const integrationKey = searchParams.get('integrationKey');
  const projectKey = searchParams.get('projectKey');
  const integrationConfigs =
    integrationKey && projectKey
      ? await getQueryClient().fetchQuery(integrationConfigurationsQuery({ integrationKey })).catch(noop)
      : null;
  const integrationConfigForProject = integrationConfigs?.items?.find((ic) => {
    const { data } = warehouseExperimentationConfigValuesSchema.safeParse(ic.configValues);

    return data?.selectedEnv?.projectKey === projectKey;
  });
  const defaultIntegrationConfig: MetricDataSourceEditorForm['dataSource']['integrationConfig'] | null =
    integrationConfigForProject
      ? (function () {
          const { data, success } = warehouseExperimentationConfigValuesSchema.safeParse(
            integrationConfigForProject.configValues,
          );

          if (
            success &&
            typeof integrationConfigForProject?._id === 'string' &&
            typeof integrationConfigForProject?._integrationKey === 'string'
          ) {
            const { selectedEnv } = data;

            return {
              environmentKey: selectedEnv.environmentKey,
              projectKey: selectedEnv.projectKey,
              key: integrationConfigForProject._integrationKey,
              id: integrationConfigForProject._id,
            };
          }

          return null;
        })()
      : null;

  return defaultIntegrationConfig;
};
